export enum OnyxMapObjectZIndex {
  VEHICLE,
  ROUTE,
  ROUTE_ACTIVE,
  MARKER,
  BORDER_POINT,
  BORDER_POINT_ACTIVE,
  ROUTE_POINT,
  ROUTE_POINT_ACTIVE,
  SELECTED_VEHICLE,
  CONTEXT_MENU,
}
